import { Component, OnInit, inject } from "@angular/core";

import { RollService } from "@core/services/roll.service";
import { NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem } from "@ng-bootstrap/ng-bootstrap";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { AppSettings, APP_SETTINGS } from "../../app.settings";
import { UserInfo, UserInfoService } from "@core/services/user-info.service";

@Component({
    selector: "app-header",
    templateUrl: "./header.component.html",
    styleUrls: ["./header.component.scss"],
    imports: [NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem, RouterLink, RouterLinkActive]
})
export class HeaderComponent implements OnInit {
    private userInfoService = inject(UserInfoService);
    private rollService = inject(RollService);

    idToken: any;
    isAuthenticated = false;
    userName = "";
    userUnit = "";
    isProduction = false;
    appVersion = "";
    gdprBaseUrl = "https://inloggning.net/gdpr";
    userRoles: string[] = [];
    userUnits: any[] = [];

    constructor() {
        const env = inject<AppSettings>(APP_SETTINGS);

        if (env.production) 
            this.isProduction = env.production;

        this.appVersion = env["appVersion"];
    }

    ngOnInit() {
        const userInfo$ = this.userInfoService.getUserInfo();

        userInfo$.subscribe((value: UserInfo) => {
            this.userName = value.fullName;
            this.userUnit = value.unit;
            this.isAuthenticated = value.isAuthenticated;
            if (!value.unit) this.changeEnhet();
            if (value.isAuthenticated) this.getUserData();
        });
    }

    private getUserData() {
        this.rollService.getUserRoles().subscribe({
            next: data => this.userRoles = data,
            error: error => console.error(error)
        });
        this.rollService.getUserUnits().subscribe({
            next: data => this.userUnits = data,
            error: error => console.error(error)
        });
    }

    isAdmin(): boolean {
        return this.userRoles.indexOf("admin") > -1;
    }

    logout() {
        this.userInfoService.logout();
    }

    changeEnhet() {
        this.userInfoService.changeUnit();
    }
}
